// extracted by mini-css-extract-plugin
module.exports = {"badge":"styles_badge__3M2D1","text":"styles_text__zblX9","vsText":"styles_vsText__3NyrR"};